import type { PointerEvent } from 'react';
import { useRef } from 'react';

type DragState = {
  directionX: number;
  directionY: number;
  distanceX: number;
  distanceY: number;
  cancel: () => void;
};

export function useDrag(handler: (state: DragState) => void) {
  const startRef = useRef<{ x: number; y: number } | null>(null);

  const onPointerDown = (event: PointerEvent<HTMLElement>) => {
    if (event.pointerType === 'touch') {
      startRef.current = { x: event.clientX, y: event.clientY };
      event.currentTarget.setPointerCapture(event.pointerId);
    }
  };

  const onPointerMove = (event: PointerEvent<HTMLElement>) => {
    if (startRef.current === null) return;

    const distanceX = event.clientX - startRef.current.x;
    const distanceY = event.clientY - startRef.current.y;

    handler({
      directionX: Math.sign(distanceX),
      directionY: Math.sign(distanceY),
      distanceX: Math.abs(distanceX),
      distanceY: Math.abs(distanceY),
      cancel: () => {
        startRef.current = null;
      },
    });
  };

  const onPointerUp = () => {
    startRef.current = null;
  };

  return {
    onPointerDown,
    onPointerMove,
    onPointerUp,
    onPointerCancel: onPointerUp,
  };
}
